import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useFirestoreConnect } from 'react-redux-firebase';

import { useTheme } from '../../ThemeContext';

import Modal from '../Modal';
import ProfileManageBasic from '../ProfileManageBasic';
import ProfileManageUsers from '../ProfileManageUsers';
import ProfileManageBilling from '../ProfileManageBilling';

import { Wrapper } from './ProfileManage.style';

import roles from '../../roles';

const ProfileManageInner = ({ handleClose = () => {} }) => {
  const intl = useIntl();
  const theme = useTheme();
  const INITIAL_TAB = 'EDIT_PROFILE';
  const [currentTab, setCurrentTab] = useState(INITIAL_TAB);
  const firebaseStore = useSelector((state) => state.firebase);
  const { auth, profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;
  const userCompany = useSelector(
    (state) => state.firestore.data['userCompany']
  );
  const userCompanyRole =
    userCompany &&
    userCompany.admins &&
    userCompany.admins.length > 0 &&
    userCompany.admins.find((admin) => admin.id === auth.uid)
      ? 'isAdmin'
      : userCompany &&
        userCompany.users &&
        userCompany.users.length > 0 &&
        userCompany.users.find((user) => user.id === auth.uid)
      ? 'isUser'
      : undefined;
  const authRole = roles.find(
    (role) => userCompanyRole && role.id === userCompanyRole
  );
  const isAvailableDisplayUsers =
    authRole &&
    authRole.privileges &&
    authRole.privileges['MANAGE_COMPANY_USER'];
  const isAvailableDisplayBillings =
    authRole &&
    authRole.privileges &&
    authRole.privileges['MANAGE_COMPANY_BILLING'];
  const tabs = [
    'EDIT_PROFILE',
    isAvailableDisplayUsers ? 'USERS' : undefined,
    isAvailableDisplayBillings ? 'ACCOUNT_AND_BILLING' : undefined,
  ].filter((tab) => tab);

  const handleChangeTab = (tab) => setCurrentTab(tab);

  const firestoreConnect = [];
  if (isProfileCompany)
    firestoreConnect.push({
      collection: 'companies',
      doc: profile.company.id,
      storeAs: 'userCompany',
    });
  useFirestoreConnect(firestoreConnect);

  useEffect(() => {
    if (
      !isProfileCompany ||
      (isProfileCompany && !isAvailableDisplayUsers && currentTab === 'USERS')
    )
      setCurrentTab(INITIAL_TAB);
    else if (
      !isProfileCompany ||
      (isProfileCompany &&
        !isAvailableDisplayBillings &&
        currentTab === 'ACCOUNT_AND_BILLING')
    )
      setCurrentTab(INITIAL_TAB);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProfileCompany]);

  return (
    <Wrapper theme={theme.profileManage.wrapper}>
      {currentTab === 'EDIT_PROFILE' ? (
        <ProfileManageBasic
          currentTab={currentTab}
          tabs={tabs.map((tab) => ({
            key: tab,
            name: intl.formatMessage({ id: `PROFILE_MANAGE.TAB.${tab}` }),
          }))}
          handleClose={handleClose}
          handleChangeTab={(tab) => {
            handleChangeTab(tab);
          }}
        />
      ) : isProfileCompany &&
        isAvailableDisplayUsers &&
        currentTab === 'USERS' ? (
        <ProfileManageUsers
          currentTab={currentTab}
          tabs={tabs.map((tab) => ({
            key: tab,
            name: intl.formatMessage({ id: `PROFILE_MANAGE.TAB.${tab}` }),
          }))}
          handleClose={handleClose}
          handleChangeTab={(tab) => {
            handleChangeTab(tab);
          }}
        />
      ) : isProfileCompany &&
        isAvailableDisplayBillings &&
        currentTab === 'ACCOUNT_AND_BILLING' ? (
        <ProfileManageBilling
          currentTab={currentTab}
          tabs={tabs.map((tab) => ({
            key: tab,
            name: intl.formatMessage({ id: `PROFILE_MANAGE.TAB.${tab}` }),
          }))}
          handleChangeTab={(tab) => {
            handleChangeTab(tab);
          }}
        />
      ) : (
        ''
      )}
    </Wrapper>
  );
};

const ProfileManage = ({ handleClose = () => {} }) => {
  return (
    <Modal
      handleClose={() => {
        handleClose();
      }}
    >
      <ProfileManageInner
        handleClose={() => {
          handleClose();
        }}
      />
    </Modal>
  );
};

ProfileManageInner.propTypes = {
  handleClose: PropTypes.func,
};

ProfileManage.propTypes = {
  handleClose: PropTypes.func,
};

export default ProfileManage;
